var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1017",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    xmlnslink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1018"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1019"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.707V5.61l3.517 3.517c1.413 1.37 3.496-.703 2.122-2.123L17.06.926a1.475 1.475 0 0 0-.444-.296 1.527 1.527 0 0 0-1.678.296L8.861 7.004c-.955.89-.224 2.607 1.061 2.561.384 0 .768-.146 1.061-.44L14.5 5.61v16.098c.03 1.963 2.967 1.98 3.002 0z",
    className: "svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.343 21.707v2.214c0 4.179 3.4 7.579 7.58 7.579h12.155c4.179 0 7.579-3.4 7.579-7.579v-2.214a1.5 1.5 0 0 0-3.002 0v2.214a4.583 4.583 0 0 1-4.577 4.578H9.922a4.583 4.583 0 0 1-4.577-4.578v-2.214a1.5 1.5 0 0 0-3.002 0z",
    className: "svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload-file-icon.9ea54efe24875679ad780721c66e58ab.svg";
export { ForwardRef as ReactComponent };